import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "col-span-12" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import PageLoader from '@/components/PageLoader.vue';
import Rider from '@/classes/Rider';

import { useRoute } from 'vue-router';
import { ref } from 'vue';
import { replaceDashWithBackslash } from '@/helpers/PackageRiderHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route     = useRoute();
const loader    = ref(false)
const showError = ref(false);
const errorMsg  = ref(false);
const form      = ref({})
const riderName = ref(route.params.name);
const riderType = ref(route.params.name);

const tabs: { name: string, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        href: `/contents/riders/show/${riderName.value}`,
        allowed: true
    },
    {
        name: 'Schedule',
        href: `/contents/riders/schedule/${riderName.value}`,
        allowed:
            window.$hasPermission('update-package-and-rider-schedule')
    },
];

const fetchRider = async () => {
    try {
        loader.value = true;
        const formttedValue = replaceDashWithBackslash(riderName.value);

        const response   = await Rider.showRider(replaceDashWithBackslash(formttedValue));
        loader.value = false;

        Object.assign(form.value, response.data[0])

    } catch (err) {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = err.response.data.message;

            if (err.response.status === 422) {
                // setTimeout(() => {
                //     window.location.assign('/contents/riders');
                // }, 1500);
            }
    }
    finally{
        loader.value = false
    }
}

// onMounted(() => fetchRider())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Rider",
    "show-back": "",
    backUrl: "/contents/riders"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, null, {
          title: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Rider Information ", -1)
          ]))]),
          description: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Relevant data and other details ", -1)
          ]))]),
          form: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TextInput, {
                modelValue: riderName.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((riderName).value = $event)),
                id: "riderName",
                name: "riderName",
                disabled: "",
                label: "Rider Name",
                placeholder: "Rider Name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(TextInput, {
                modelValue: riderType.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((riderType).value = $event)),
                id: "riderType",
                name: "riderType",
                disabled: "",
                label: "Rider Type",
                placeholder: "Rider Type"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})